import YakFetch from './utils/yak_fetch';
import ServiceBase from './service_base';

export default class Subscriber extends ServiceBase {

  static async subscribe(cardToken) {
    const endpoint = `${process.env.REACT_APP_SERVICE_ENDPOINT_BASE}/api/subscriptions`
    const response = await YakFetch.fetch(endpoint, 'POST', { body: { card_token: cardToken } });
    await Subscriber._abortIfUnsuccessful(response);
    const subscriptionData = await response.json();
    return subscriptionData;
  }

  static async fetch(email) {
    const endpoint = `${process.env.REACT_APP_SERVICE_ENDPOINT_BASE}/api/subscriptions/${email}`
    const response = await YakFetch.fetch(endpoint, 'GET');
    await Subscriber._abortIfUnsuccessful(response);
    const subscriptionData = await response.json();
    return subscriptionData;
  }

  static async cancel(email) {
    const endpoint = `${process.env.REACT_APP_SERVICE_ENDPOINT_BASE}/api/subscriptions/${email}`
    const response = await YakFetch.fetch(endpoint, 'DELETE');
    await Subscriber._abortIfUnsuccessful(response);
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/services/subscriber.js